import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Dropdown from './Dropdown';
import AutoComplete from './AutoComplete';
import AutoCompleteDropdown from './AutoCompleteDropdown';
import RippleButton from 'components/PartnerPage/RippleButton';
import { useQuickQuoteContext } from 'contexts/QuickQuoteContext';

function QuickQuoteForm({
  buttonText = 'Book in less than two minutes', breakText = 'Rates start at $49'
}) {
  const {
    from, to, product, handleFromSelect, handleToSelect, allowedLocations,
    handleProductSelect, handleSubmit, loading, activeProducts, shippingData
  } = useQuickQuoteContext();

  const isDisabled = !from || !to || !product || loading;

  useEffect(() => {
    if (shippingData) {
      window?.quickQuoteRudderstackEvent([product], from, to, shippingData?.international, shippingData?.rates);
    }
  }, [shippingData]);

  return (
    <form className="w-full" onSubmit={(event) => {
      event.preventDefault();
      if (!loading && product && from && to) {
        handleSubmit();
      }
    }}>
      <AutoComplete
        label="From"
        placeholder="Pickup or drop off location"
        onSelect={handleFromSelect}
      />
      {allowedLocations ? (
        <AutoCompleteDropdown
          label="To"
          options={allowedLocations}
          onSelect={handleToSelect}
        />
      ) : (
        <AutoComplete
          label="To"
          placeholder="Destination"
          onSelect={handleToSelect}
          />
      )}
      <Dropdown
        label="Product"
        options={activeProducts}
        onSelect={handleProductSelect}
      />

      <div className="w-full flex items-center justify-center my-4 py-2 px-4">
        <div className="flex-grow border-t border-gray-300"></div>
        <span className="mx-4 text-lg text-gray-600 font-bold">
          {breakText}
        </span>
        <div className="flex-grow border-t border-gray-300"></div>
      </div>

      <div className="w-full 2xl:w-3/4 mx-auto px-4 py-3">
        <RippleButton
          className={`
            flex items-center justify-center bg-[#4FAB55] text-white rounded-full
            py-2 px-4 h-[67px] w-full
            ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}
          `}
            type="submit"
            disabled={isDisabled}
            aria-label={buttonText}
            style={{ transition: 'background-color 0.3s' }}
            >
          <span>{buttonText}</span>
        </RippleButton>
      </div>
    </form>
  );
}

QuickQuoteForm.propTypes = {
  allowedLocations: PropTypes.array,
  buttonText: PropTypes.string,
  breakText: PropTypes.string,
};

export default QuickQuoteForm;
